import React, { Component } from 'react'

import WidgetAjax from '../../widget/WidgetAjax';
import Config from '../../config/Config';

import Credit from './riskModular/credit';
import Frfraud from './riskModular/Frfraud';
import Faketrade from './riskModular/Faketrade';
import Shell from './riskModular/Shell';
import Affiliation from './riskModular/Affiliation';
import Bepres from './valuationModular/bepres';

import '../../css/common.css';

class Risk extends Component 
{
    constructor( props )
    {
        super(props);

        this.state = {
            basePath: Config.getBasePath(),
            curIndex: 0, // 高亮下标
            headerTop: null, // header到顶部的距离
            headerHeight: null, // header的高度
            consTops: [], 
            navList: [
                {
                  id: 'BEPRES',
                  text: '市场竞争能力'
                },
                // {
                //   id: 'FRFRAUD',
                //   text: '财报造假风险'
                // },
                // {
                //   id: 'FAKETRADE',
                //   text: '虚假交易风险'
                // },
                // {
                //   id: 'SHELL',
                //   text: '空壳企业综合'
                // },
                // {
                //   id: 'AFFILIATION',
                //   text: '关联风险'
                // }
              ],
              ENVS:{
                ability_eslength_tp: "",
                ability_vendinc_tp: "",
                nic_name: "",
                ptil_envs: "",
                ptil_envs_eslength_tp: "",
                ptil_envs_indsy: "",
                ptil_envs_region: "",
                ptil_envs_vendinc_tp: "",
                r_envs_op: "",
                r_illegal_all: "",
                rank_envs: "",
                rank_envs_eslength_tp: "",
                rank_envs_region: "",
                rank_envs_vendinc_tp: "",
                rank_evrt_s101: "",
                rank_evrt_s102: "",
                rank_evrt_s103: "",
                region_name: "",
                score_envs: ""
              }
        }
    }

    componentDidMount()
    {
        const { ENTNAME,curIndex } = this.props;
        
        this.getData(ENTNAME,'ENVS')
        
    }

    componentDidUpdate()
    {
        let headerTopNew = this.header.offsetTop;
        let headerHeightNew =  this.header.clientHeight;
        let consTopsNew = [...this.main.children].map(item => item.offsetTop);
        if (this.state.consTops.length === 0)
        {
            this.setState({
                headerTop:headerTopNew,  
                headerHeight:headerHeightNew,
                consTops:consTopsNew
            });
        }
    }

    componentWillReceiveProps(nextprops) {
        let overviewWhiteHeight = document.querySelector('.overview.white').clientHeight
        let tabStyleClass = document.querySelector('.tab.tabStyleClass').clientHeight
        let curIndex = this.state.curIndex;
        const {navList} = this.state

        // tabStyleClass.scrollTop + tabStyleClass.clientHeight >= tabStyleClass.scrollHeight


            this.state.consTops.forEach((top, index) => 
            {
                if (nextprops.scrollTop >= top-this.state.headerHeight - overviewWhiteHeight - tabStyleClass) 
                {
                    curIndex = index;
                }
                else if(nextprops.scrollTop === 0)
                {
                    curIndex = 0;
                }
                else if(nextprops.scrollTop + nextprops.clientHeight >= nextprops.scrollHeight )
                {
                    curIndex = navList.length-1;
                }
            })

            this.setState({ curIndex });
    }
    
    getData(ENTNAME,type){
        const { basePath } = this.state;
        WidgetAjax.ajax({ url: basePath + '/entity/financial_portrait', params: {ENTNAME,EVALTYPE:type}, callback: (e)=>{

            this.setState({
                ENVS:e.result.EVALS
            })

        } });
    }
 

    changeTab(e , id, index) 
    {
        // 点击导航跳转获取对应的位置，滚动位置
        let overviewWhiteHeight = document.querySelector('.overview.white').clientHeight
        let tabStyleClass = document.querySelector('.tab.tabStyleClass').clientHeight
       
        this.props.setScrollTop(this.state.consTops[index] - this.state.headerHeight - tabStyleClass - overviewWhiteHeight);

        this.setState({
            curIndex: index,
            contentType: id+'_id'
        });
    }

    render()
    {
        const { navList, curIndex, headerTop, ENVS, positionOptions, profitOptions, growthOptions, payableOptions, berprsOptions} = this.state;
        const { scrollTop } = this.props


        return (
            <div className="page entity-panorama">
                <div className="nav-height" ref={el => this.header = el}>
                    <div className="page-weidu entity-title"  style={this.props.headersHeight>0?{width:"936px",zIndex:"100",marginTop:"6px",borderTop:"1px solid",borderRadius:"0"}:{position:"none"}}>
                    {/* <div className="page-weidu entity-title"  style={this.props.headersHeight>0?{width:"936px",position:"fixed",zIndex:"100",marginTop:"6px",borderTop:"1px solid",borderRadius:"0"}:{position:"none"}}> */}
                      {navList.map((item, index) => (
                        <div
                          id={item.id}
                          className={['title-label', curIndex === index ? 'title-label title-label-active' : ''].join('')}
                          onClick={(e)=>this.changeTab(e, item.id , index)}
                        >{item.text}</div>
                      ))}
                    </div>
                </div>
                
                <div className="common-all">
                    <div className="common-box" ref={el => this.main = el}>
                        {/* <Credit title={"信用质量"} options={operationOptions} ></Credit>
                        <Frfraud title={"财报造假风险"} options={operationOptions} ></Frfraud>
                        <Faketrade title={"虚假交易风险"} options={operationOptions} ></Faketrade>
                        <Shell title={"空壳企业综合"} options={operationOptions}></Shell>
                        <Affiliation title={"关联风险"} options={operationOptions}></Affiliation> */}
                        <Bepres title={"市场竞争能力"} options={ENVS}></Bepres>
                        {/* <ValuationModular title={"市场地位"} options={positionOptions}></ValuationModular>
                        <ValuationModular title={"盈利能力"} options={profitOptions}></ValuationModular>
                        <ValuationModular title={"成长潜力"} options={growthOptions}></ValuationModular>
                        <ValuationModular title={"财务压力"} options={payableOptions}></ValuationModular>
                        <ValuationModular title={"营商环境压力"} options={berprsOptions}></ValuationModular> */}
                    </div>
                </div>
            </div>
        )
    }
}
export default Risk